import axios from 'axios';
import Cookies from 'js-cookie';
import React, { ReactNode, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppConfig } from 'src/config/AppConfig';
import { useAppDispatch } from 'src/hooks/redux/hooks';
// import { setRefreshTokens } from 'src/store/auth/authSlice';


const verifyToken = async (refreshToken: string) => {
   return await axios({
      url: `${AppConfig.DEV_SERVER}/refresh-token`,
      method: "POST",
      headers: {
         "refresh-token": refreshToken,
      }
   });
}

const AuthWrapper: React.FC<{ children: ReactNode; }> = ({ children }) => {
   // const dispatch = useAppDispatch();
   const token = Cookies.get('token');
   const refreshToken = Cookies.get('refreshToken');
   // const Admin = useAppSelector((state) => state?.auth?.adminDetails);
   const [isLoading, setIsLoading] = useState(true);

   const navigate = useNavigate();


   useEffect(() => {
      // console.log(Admin);
      const verifyAndRefreshToken = async () => {
         try {

            verifyToken(refreshToken as string).then(async (res) => {
               // console.log(res?.data)
               const data = res?.data;
               if (data?.satatus_code === "201") {

                  const token = data?.accessToken as string;
                  const refreshToken = data?.newRefreshToken as string

                  // console.log("token: " + token, "refreshToken: " + refreshToken)
                  // dispatch(setRefreshTokens(newTokens));
                  Cookies.set('token', token, { expires: 7, secure: true });
                  Cookies.set('refreshToken', refreshToken, { secure: true });
                  // console.log(newTokens)
                  // console.log("201")
               }
               else {

                  navigate("/sign-in");
                  // console.log("else")
               }
            })
               .catch((err) => {
                  console.log(err);

                  navigate("/sign-in")
               });

         } catch (err) {

            navigate("/sign-in")
         } finally {
            setIsLoading(false);
         }
      };

      if (!token || !refreshToken) {
         verifyAndRefreshToken();
      } else {
         setIsLoading(false);
      }
   }, [token]);

   if (isLoading) {
      return <div>Loading...</div>;
   }


   return <>{children}</>;
};

export default AuthWrapper;
